/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveFloridaFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrieveFloridaFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveFloridaFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveFloridaFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveFloridaFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_florida_finance_disclosure_document.proto at 9:1
 */
export const RetrieveFloridaFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveFloridaFinanceDisclosureDocumentRequest');
fixType(RetrieveFloridaFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrieveFloridaFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrieveFloridaFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_florida_finance_disclosure_document.proto at 15:1
 */
export const RetrieveFloridaFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveFloridaFinanceDisclosureDocumentResponse');
fixType(RetrieveFloridaFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrieveFloridaFinanceDisclosureDocumentResponse);